import { Button, Dialog, Typography } from "@material-tailwind/react";
import { t } from "i18next";

interface DeleteConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Dialogue de confirmation pour la suppression d'une part
 */
export default function DeleteConfirmDialog({
  open,
  onClose,
  onConfirm,
}: DeleteConfirmDialogProps) {
  return (
    <Dialog open={open} handler={onClose} size="xs">
      <div className="p-4">
        <Typography variant="h5" className="mb-2">
          {t("workorder:parts:deleteConfirmation")}
        </Typography>
        <Typography className="mb-4">
          {t("workorder:parts:deleteConfirmationMessage")}
        </Typography>
        <div className="flex justify-end gap-2">
          <Button
            onClick={onClose}
            variant="outlined"
            color="blue-gray"
            size="sm"
          >
            {t("workorder:parts:buttons:cancel")}
          </Button>
          <Button color="red" onClick={onConfirm} size="sm">
            {t("workorder:parts:buttons:delete")}
          </Button>
        </div>
      </div>
    </Dialog>
  );
} 